import { IStoreState } from "../../store/store";
import { ISiteStructureContainerState } from "./site-structure";
import { generateContainer, IContainerProps } from "../base/generate-container";
import { fetchSiteStructure } from './site-structure.actions';

const mapState = ({ siteStructure }: IStoreState): ISiteStructureContainerState => ({ ...siteStructure });

const actions = {
    fetchSiteStructure,
};

export type ISiteStructureContainerProps = IContainerProps<ReturnType<typeof mapState>, typeof actions>;
export const [SiteStructureContainer, connectWithSiteStructure, useSiteStructure] = generateContainer(mapState, actions);
